import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { canAccessInternalOps } from '@lib/utils/internalStaff';

const InternalStaffRoutes = () => {
  let user = null;

  try {
    user = JSON.parse(localStorage.getItem('user'));
  } catch (error) {
    user = null;
  }

  if (!canAccessInternalOps(user)) {
    return <Navigate to="/dashboard" replace />;
  }

  return <Outlet />;
};

export default InternalStaffRoutes;
